
<div>
  @if (form && form.controls) {
    <div class="card-body row">
      <ng-container [formGroup]="form"   class="radio-box d-flex align-items-center">
        <div class="col-10 form-group mb-0">
          <span>{{ question.text }}</span>
        </div>
        <div class="col-2 d-flex align-items-center" style="gap: 10px;">
          <div class="switch">
            <input
              type="checkbox"
              [formControlName]="question.uniqueId"
              id="switch{{ question.uniqueId }}"
              (change)="updateLabel()"
              />
              <label for="switch{{ question.uniqueId }}"></label>
            </div>
            <span class="switch-label">
              {{ switchLabel }}
            </span>
          </div>
        </ng-container>
      </div>
    }
  </div>